import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function Share({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (
    <Icon
      data-icon={'share'}
      viewBox='0 0 32 32'
      width={size}
      height={size} {...props}>
      {/* <path d='M594.432 257.173333l246.122667 192.384-246.122667 202.261334v-99.242667h-192c-71.978667 0-138.474667 23.893333-192 64.149333v-64.149333c0-105.877333 86.122667-192 192-192h192V257.173333M573.290667 170.666667c-22.08 0-42.858667 17.408-42.858667 42.752v83.157333h-128c-141.376 0-256 114.624-256 256v246.122667c0 8.554667 11.754667 10.389333 14.528 2.282666 34.773333-101.696 126.272-184.426667 241.472-184.426666h128v80.384c0 25.408 20.842667 42.752 42.88 42.752 9.216 0 18.666667-3.029333 26.88-9.792L901.76 482.112a42.666667 42.666667 0 0 0-0.810667-66.581333L599.381333 179.797333A42.026667 42.026667 0 0 0 573.290667 170.666667z' fill='currentColor' /> */}

      <path d='M2,29A1.12,1.12,0,0,1,1.69,29,1,1,0,0,1,1,28V27A19,19,0,0,1,17,8.24V4a1,1,0,0,1,1.6-.8l12,9a1,1,0,0,1,0,1.6l-12,9A1,1,0,0,1,17,22V18.25A18.66,18.66,0,0,0,4.93,25.67L2.81,28.59A1,1,0,0,1,2,29ZM19,6V9.12a1,1,0,0,1-.89,1,17,17,0,0,0-15,14.6l.16-.21A20.68,20.68,0,0,1,17.9,16.11a1,1,0,0,1,.77.26,1,1,0,0,1,.33.74V20l9.33-7Z' />

    </Icon>
  );
}

export default styled(Share)``;